import type { CustomComponent, CustomComponentInstance } from '../types'
import CommandBarFooter from '@/composables/useCommandBar/customComponents/components/footer/CommandBarFooter.vue'
import { createApp } from 'vue'

const customComponentRootNode = document.createElement('div')
createApp(CommandBarFooter).mount(customComponentRootNode)

const CustomFooterComponent: CustomComponent = {
  mount(node: HTMLElement): CustomComponentInstance {
    return {
      render: (): void => {
        node.innerHTML = customComponentRootNode.innerHTML
      },
      unmount: (): void => {},
    }
  },
}

export const registerFooterComponent = (): void => {
  window?.CommandBar?.setCustomComponent('footer', () => CustomFooterComponent)
}
